<template>
  <div class="plotly_screen">
    <div
      :id="propsid"
      class="plotly"
      @mouseover="$emit('hover')"
      @mouseleave="$emit('unhover')"
    />
  </div>
</template>

<script>
import Plotly from 'plotly.js-dist-min';

export default {
  name: 'Plotly',
  props: {
    data: {
        type: Array,
        required: true
    },
    layout:{
        type:Object,
        required: true
    },
    propsid:{
        type:String,
        required: true
    },
  },
  data(){
    return{
        config: {
            scrollZoom: false,
            editable: false,
            displaylogo: false,
            responsive: true,
            modeBarButtonsToRemove: ['select2d','lasso2d', 'resetScale2d']
        }
    }
  },
  mounted() {
    Plotly.newPlot(this.propsid, this.data, this.layout, this.config);
  },
  methods: {
    relayout(layoutUpdate){
      Plotly.relayout(this.propsid, layoutUpdate);
    }
  }
};
</script>

<style scoped>
.plotly {
  width: 100%;
  height: 100%;
  position: relative;
  padding:0.5rem
}
.plotly_screen{
  height: 100%;
    padding: 0rem 0.5rem;
}
</style>